export default "__VITE_ASSET__8f3c2f38__$_?component__"